export const REGISTER_ACTIONS: { [key: string]: string } = [
  'REGISTER_ACCOUNT',
  'DELETE_TOKEN'
].reduce((acc, a) => ({ ...acc, [a]: `REGISTER/${a}` }), {});
